/**
 * TMMAPI-0114 `editableFields`. The product-admin path writes the array; a stub that omits it
 * is treated as empty so a missing key never throws and never shows Edit details.
 */
export function fieldList(fields: readonly string[] | null | undefined): readonly string[] {
  return fields ?? [];
}

export function hasEditableFields(fields: readonly string[] | null | undefined): boolean {
  return fieldList(fields).length > 0;
}

export function fieldEditable(fields: readonly string[] | null | undefined, key: string): boolean {
  return fieldList(fields).includes(key);
}
